import {CommonMessages} from '../common.messages';

export const PanelClientsEditAmlSourceOfFundsMessages = {
    RequestFailedFailed: {
        key: 'RequestFailedFailed',
        message: 'Error while communication with the server. Unable to update source of funds.'
    },
    ...CommonMessages
};
